import type { TenantConfig } from '@/types/TenantConfig'

const white = '#FFFFFF'
const green = '#84BD01'
const blue = '#0073B0'
const coolGray = '#D8D7CB'
const magenta = '#9B1889'
const darkGray = '#616365'
const dividerColor = '#EDECE7'

export const phsonline: TenantConfig = {
  logo: 'assets/phsonline/static/logo.svg',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: green,
    secondaryColor: blue,
    logoHeight: '50px',
    headerHeight: '120px',
    headerBottomBorder: `2px solid ${dividerColor}`,
    memberLinksColor: magenta,
    cartHeaderBackgroundColor: darkGray,
    cartHeaderTextColor: white,
    footerBackgroundColor: coolGray,
    footerTextColor: '#272727',
    dialog: {
      headerBackground: darkGray,
      headerTextColor: white,
      headerIconColor: white,
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/phsonline/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-160px',
        mobile: '-100px',
      },
    },
  },
}
